import request from '@/utils/request'

// 查询服务机构管理列表
export function listFwjg(query) {
  return request({
    url: '/web/fwjg/fwjg/list',
    method: 'get',
    params: query
  })
}

// 查询服务机构管理详细
export function getFwjg(recid) {
  return request({
    url: '/web/fwjg/fwjg/' + recid,
    method: 'get'
  })
}

// 新增服务机构管理
export function addFwjg(data) {
  return request({
    url: '/web/fwjg/fwjg',
    method: 'post',
    data: data
  })
}

// 修改服务机构管理
export function updateFwjg(data) {
  return request({
    url: '/web/fwjg/fwjg/edit',

    method: 'post',
    data: data
  })
}

// 删除服务机构管理
export function delFwjg(recid) {
  return request({
    url: '/web/fwjg/fwjg/remove/' + recid,

    method: 'post',
  })
}

// 导出服务机构管理
export function exportFwjg(query) {
  return request({
    url: '/web/fwjg/fwjg/export',
    method: 'get',
    params: query
  })
}

// 查询黑名单等信息
export function getHmdOtherDetail(recid) {
  return request({
    url: '/web/fwjg/fwjg/getHmdOtherDetail/' + recid,
    method: 'get'
  })
}